// ===== Společné nastavení obchodu (používá index.html i cart.html) =====
// Shopify: vyplň doménu obchodu a ID variant (Admin > Produkty > varianta > ID v URL).
// Dokud je SHOP_DOMAIN prázdná, tlačítko pokladny jen zobrazí upozornění.
// Ve Shopify theme se vše vyplní samo (viz layout/theme.liquid): produkty se hledají podle názvu (handle).
const ON_SHOPIFY = typeof window.RS_ASSETS === "object";
const CART_URL = ON_SHOPIFY ? "/cart" : "cart.html";
const HOME_URL = ON_SHOPIFY ? "/" : "index.html";
const ebookEn = () => (savedLang === "en" || savedLang === "cs") ? savedLang === "en" : !!window.RS_EBOOK_EN;
const ebookImg = () => ebookEn() ? "ebook-en.png" : "ebook.png";
const asset = n => ON_SHOPIFY ? (RS_ASSETS[n.replace(/\.png$/, ".jpg")] || RS_ASSETS[n] || "") : "assets/" + n;

// Jen pro ruční použití mimo Shopify theme:
const SHOP_DOMAIN = "";                              // např. "restlysleep.myshopify.com"
const VARIANTS = (window.RS_SHOP && RS_SHOP.variants) || { 1: "", 2: "", 3: "" };   // ID variant pro balíček 1 / 2 / 3 kusy
// E-book zdarma u balíčku 3 kusů: ve Shopify nastav automatickou slevu 100 % na e-book, když je v košíku balíček 3 kusů.
const ADDON_VARIANTS = (window.RS_SHOP && RS_SHOP.addons) || { protect: "", ebook: "" };   // ID variant pro Ochranu přepravy a E-book

const PRICES = {
  cs: { cur: "Kč", now: {1: 799, 2: 1439, 3: 1989}, old: {1: 959, 2: 1599, 3: 2399}, ship: 99,   addon: { protect: 89,   ebook: 199 } },
  en: { cur: "€",  now: {1: 32.99, 2: 59.49, 3: 81.99}, old: {1: 39.59, 2: 65.99, 3: 98.99}, ship: 4.9, addon: { protect: 3.69, ebook: 7.99 } }
};

// Jazyk: uložená volba; poprvé podle měny trhu ve Shopify (CZK = česky, jinak anglicky).
var savedLang = localStorage.getItem("rs_lang");
let lang = savedLang === "en" || savedLang === "cs" ? savedLang : (ON_SHOPIFY && window.RS_CURRENCY && window.RS_CURRENCY !== "CZK" ? "en" : "cs");

// Měna se řídí jazykem: čeština = koruny, angličtina = eura (na celém webu).
const cur = () => lang;

function fmt(n) {
  const c = cur(), p = PRICES[c];
  if (c === "cs") return n.toLocaleString("cs-CZ") + " " + p.cur;
  return p.cur + n.toLocaleString("en-IE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Košík: cart = { "1": počet, "2": počet, "3": počet } (balíčky), addons = { protect: počet, ebook: počet }
const load = key => { try { return JSON.parse(localStorage.getItem(key) || "{}"); } catch { return {}; } };
let cart = load("rs_cart");
let addons = load("rs_addons");

const hasThree = () => (cart[3] || 0) > 0;
const freeEbook = () => hasThree();
const cartCount = () => Object.values(cart).reduce((s, q) => s + q, 0) + (addons.protect || 0) + (freeEbook() ? 0 : addons.ebook || 0);

function saveCart() {
  Object.keys(cart).forEach(k => { if (!cart[k]) delete cart[k]; });
  if (!Object.keys(cart).length) addons = {};
  if (freeEbook()) delete addons.ebook;
  Object.keys(addons).forEach(k => { if (!addons[k]) delete addons[k]; });
  localStorage.setItem("rs_cart", JSON.stringify(cart));
  localStorage.setItem("rs_addons", JSON.stringify(addons));
  document.dispatchEvent(new Event("cartchange"));
}

function addToCart(pack) {
  cart[pack] = (cart[pack] || 0) + 1;
  saveCart();
}

// Adresa pokladny ve Shopify; prázdný řetězec, dokud není nastavená doména a ID variant.
function checkoutUrl() {
  const parts = [];
  Object.entries(cart).forEach(([k, q]) => { if (q > 0 && VARIANTS[k]) parts.push(`${VARIANTS[k]}:${q}`); });
  if ((addons.protect || 0) > 0 && ADDON_VARIANTS.protect) parts.push(`${ADDON_VARIANTS.protect}:${addons.protect}`);
  const eb = freeEbook() ? 1 : addons.ebook || 0;
  const ebId = ebookEn() ? (ADDON_VARIANTS.ebookEn || ADDON_VARIANTS.ebook) : ADDON_VARIANTS.ebook;
  if (eb > 0 && ebId) parts.push(`${ebId}:${eb}`);
  const base = ON_SHOPIFY ? "" : SHOP_DOMAIN ? `https://${SHOP_DOMAIN}` : null;
  return base !== null && parts.length ? `${base}/cart/${parts.join(",")}` : "";
}

// ===== Kontakt =====
// Mimo Shopify se po kliknutí na "Kontaktujte nás" nebo na e-mail otevře okno s možnostmi, jak napsat.
// Ve Shopify theme vedou stejné odkazy na stránku /pages/kontakt s formulářem.
const CONTACT_EMAIL = "restly.sleeps@gmail.com";
const CONTACT_T = {
  cs: { h: "Napište nám", p: "Rádi vám pomůžeme s objednávkou, dopravou i vrácením peněz. Napište nám na:", mail: "Otevřít v e-mailové aplikaci", gmail: "Napsat e-mail v Gmailu", copy: "Zkopírovat adresu", copied: "Zkopírováno", close: "Zavřít", subj: "Dotaz – RestlySleep" },
  en: { h: "Write to us", p: "We are happy to help with your order, delivery or a refund. Write to us at:", mail: "Open in your email app", gmail: "Write an email in Gmail", copy: "Copy address", copied: "Copied", close: "Close", subj: "Question – RestlySleep" }
};
let contactEl = null;

function closeContact() { if (contactEl) contactEl.classList.remove("open"); document.body.classList.remove("lock"); }

function openContact() {
  const t = CONTACT_T[lang], subj = encodeURIComponent(t.subj);
  if (!contactEl) {
    contactEl = document.createElement("div");
    contactEl.className = "contact-modal";
    contactEl.addEventListener("click", e => { if (e.target === contactEl || e.target.closest(".cm-x")) closeContact(); });
    document.addEventListener("keydown", e => { if (e.key === "Escape") closeContact(); });
    document.body.appendChild(contactEl);
  }
  contactEl.innerHTML = `<div class="contact-box" role="dialog" aria-modal="true" aria-label="${t.h}">
    <button type="button" class="cm-x" aria-label="${t.close}">✕</button>
    <h3>${t.h}</h3><p>${t.p}</p>
    <b class="cm-mail">${CONTACT_EMAIL}</b>
    <a class="cta" target="_blank" rel="noopener" href="https://mail.google.com/mail/?view=cm&fs=1&to=${CONTACT_EMAIL}&su=${subj}">${t.gmail}</a>
    <a class="cta ghost" href="mailto:${CONTACT_EMAIL}?subject=${subj}">${t.mail}</a>
    <button type="button" class="cta ghost cm-copy">${t.copy}</button>
  </div>`;
  contactEl.querySelector(".cm-copy").addEventListener("click", e => {
    const b = e.currentTarget;
    const done = () => { b.textContent = t.copied + " ✓"; setTimeout(() => { b.textContent = t.copy; }, 2000); };
    if (navigator.clipboard) navigator.clipboard.writeText(CONTACT_EMAIL).then(done, done); else done();
  });
  contactEl.classList.add("open");
  document.body.classList.add("lock");
}

if (!ON_SHOPIFY) {
  document.addEventListener("click", e => {
    const a = e.target.closest('a[href="#kontakt"], a[href^="mailto:"]');
    if (!a || a.closest(".contact-box")) return;
    e.preventDefault();
    openContact();
  });
}
